import React, { Component } from "react";
import Image from '../global/Image';

export default class PageImageText extends Component {
  	
	render() {
		
		const block = this.props.block; 
		
		return (
			
			<div className="l-grid">
			
				<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-5-12 l-grid__col--xl-4-12">
					
					{block.src &&
						
						<div className="c-page__block c-page__block--text-space">
								
							<Image width={block.width} height={block.height} srcset={block.srcset} src={block.src} />
													
						</div>
					
					}
					
				</div>
				
				<div className="l-grid__col l-grid__col--m-6-12 l-grid__col--l-push-1-12 l-grid__col--xl-push-2-12">
					
					{block.large_text &&
						
						<div className="c-page__block c-page__block--text-space">
								
							<div className="scope-text scope-text--large" dangerouslySetInnerHTML={{__html:block.large_text}}></div>
													
						</div>
					
					}
					
					{block.text &&
						
						<div className="c-page__block c-page__block--load-effect">
								
							<div className="scope-text scope-text--page" dangerouslySetInnerHTML={{__html:block.text}}></div>
													
						</div>
					
					}
					
				</div>
				
				<div className="l-grid__col">
					
					<div className="c-page__block"></div>
				
				</div>
			
			</div>
			
		)
		
	}
							
}